/*  
This component shows the last fetched data's date and time. Gets rendered at every page (service inventory, platform dashboard, customer 
solution dashboard). This component is called by CsVersionTable.js file, Home.js file, PltVersionTable.js file.
*/

import React from 'react';
import './Updatedtime.css';

const Updatedtime = ({ environmentTime, loading }) => {
  const displayTime = loading 
    ? "Loading..." 
    : (environmentTime || "None selected");

  return (
    <div className='updatedtime'>
      <h4 className="time-display" > 
        Last Updated:   
        <span className="time">{displayTime}</span> 
      </h4>
    </div>
  );
};

export default Updatedtime;